import { Box, Card, CardContent, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { PedidoType } from "src/types";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Formater, TypeRecords } from "src/framework/commons";
import { CardPedido } from "../Pagamento/CardPedido";

import './styles.scss';
import { ETAPAS_PAGAMENTO, SITUACOES_PAGAMENTO } from "src/constants";
import { InputInfo } from "src/framework/components/forms";
import theme from "src/theme/light";

export interface PagamentoListagemProperties {
    pedidos: PedidoType[];
    statusServicoCupom: any;
    onReload?: (codigoVenda: string) => void;
}


interface PagamentoRowProperties {
    pedido: PedidoType;
    statusServicoCupom: any;
    onReload: () => void;
    widthScreen: number;
}

const PagamentoRow: FC<PagamentoRowProperties> = ({
    pedido,
    statusServicoCupom,
    onReload,
    widthScreen,
}) => {

    const [open, setOpen] = useState(false);

    // useEffect(() => {
    //     if (open) {
    //         pedido.codigo_cupom = "ABC123";
    //     }
    // }, [open])

    return <>
        <TableRow key={pedido.id}>
            <TableCell width={80}>{pedido?.codigo_venda}</TableCell>
            <TableCell >{Formater.toString(pedido?.created_at, TypeRecords.DATE_TIME)}</TableCell>

            <TableCell>{pedido?.situacao ? SITUACOES_PAGAMENTO[pedido?.situacao].nome : "Aguardando Pagamento"}</TableCell>
            <TableCell>{pedido?.etapa_pagamento ? ETAPAS_PAGAMENTO[pedido?.etapa_pagamento].nome : "Pedido recebido"}</TableCell>
            <TableCell align="right">{Formater.toString(pedido?.valor_pedido, TypeRecords.CURRENCY)}</TableCell>
            <TableCell align="right">{Formater.toString(pedido?.valor_pendente, TypeRecords.CURRENCY)}</TableCell>
            <TableCell>{pedido?.codigo_cupom}</TableCell>

            <TableCell width={1}>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={100}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                        <div className="row">
                            <CardPedido
                                pedido={pedido}
                                statusServicoCupom={statusServicoCupom}
                                widthScreen={widthScreen}
                                onReload={() => {
                                    if (onReload) {
                                        onReload();
                                    }
                                }}
                            />
                        </div>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </>

}

interface PagamentoRowMobileProperties {
    pedido: PedidoType;
    statusServicoCupom: any;
    onReload: () => void;
    valorScroll: number;
    widthScreen: number;
}

const PagamentoRowMobile: FC<PagamentoRowMobileProperties> = ({
    pedido,
    statusServicoCupom,
    onReload,
    valorScroll,
    widthScreen,
}) => {
    const [open, setOpen] = useState(false);

    return <>
        <div style={{ paddingTop: "10px"}} id={`ped-${pedido.id}`}>
            <Card key={`card-${pedido.id}`}>
                <CardContent>
                    <div className="card-pedido">
                        <InputInfo
                            label="Código Venda"
                            text={pedido?.codigo_venda} />

                        <InputInfo
                            label="Data Pedido"
                            text={Formater.toString(pedido?.created_at, TypeRecords.DATE_TIME)} />

                        <InputInfo
                            label="Situação"
                            text={pedido?.situacao ? SITUACOES_PAGAMENTO[pedido?.situacao].nome : "Aguardando Pagamento"} />

                        <InputInfo
                            label="Última Etapa"
                            text={pedido?.etapa_pagamento ? ETAPAS_PAGAMENTO[pedido?.etapa_pagamento].nome : "Pedido recebido"} />

                        <InputInfo
                            label="Valor total pedido"
                            className="label-total-pedido"
                            text={Formater.toString(pedido?.valor_pedido, TypeRecords.CURRENCY)} />

                        <InputInfo
                            label="Valor Pendente"
                            className="label-total-pedido"
                            text={Formater.toString(pedido?.valor_pendente, TypeRecords.CURRENCY)} />

                        <InputInfo
                            label="Cupom"
                            text={pedido?.codigo_cupom} />

                        <div className="icone-pedido">
                            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            <strong style={{ color: theme.palette.primary.main, fontSize: "12px" }}>VER MAIS</strong> {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <div style={{width: "100%"}}>
                <div className="card-pedido-detalhe" style={widthScreen <= 330 ? {width: "265px"} : {}}>
                    <Collapse in={open} timeout="auto" unmountOnExit style={{width: "100%"}}>
                        <Box marginTop={1} marginLeft={1} style={{maxWidth: "100%"}}>
                            <CardPedido
                                        pedido={pedido}
                                        statusServicoCupom={statusServicoCupom}
                                        widthScreen={widthScreen}
                                        onReload={() => {
                                            if (onReload) {
                                                onReload();
                                            }
                                        }}
                                    />
                        </Box>
                    </Collapse>
                </div>
            </div>
        </div>
    </>
}

const PagamentoListagem: FC<PagamentoListagemProperties> = ({
    pedidos,
    statusServicoCupom,
    onReload,
}) => {

    const [widthScree, setWidthScree] = useState<number>(window.innerWidth);
    const [valorScroll, setValorScroll] =  useState<number>(0.8466 * window.innerWidth);

    const atualizarTamanhoTela = () => {
        setWidthScree(window.innerWidth);
        setValorScroll(0.8433 * window.innerWidth)
    }

    useEffect(() => {
        window.addEventListener('resize', atualizarTamanhoTela);
    }, [])

    return <>
        <div className="PagamentoListagem">
            {widthScree <= 950 ? <>
                {pedidos?.map((pedido, index) => (
                    <PagamentoRowMobile
                        key={`pedido-mobile-${pedido.id}-${index}`}
                        pedido={pedido}
                        statusServicoCupom={statusServicoCupom}
                        valorScroll={valorScroll}
                        widthScreen={widthScree}
                        onReload={() => {
                            if (onReload) {
                                onReload(pedido.codigo_venda);
                            }
                        }} />
                ))}
            </> :
                <TableContainer className="X12">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Codigo venda</TableCell>
                                <TableCell>Data pedido</TableCell>
                                <TableCell>Situação</TableCell>
                                <TableCell>Última Etapa</TableCell>
                                <TableCell align="right">Valor total pedido</TableCell>
                                <TableCell align="right">Valor Pendente</TableCell>
                                <TableCell>Cupom</TableCell>
                                <TableCell>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pedidos?.map((pedido, index) => (
                                <PagamentoRow
                                    key={`pedido-${pedido.id}-${index}`}
                                    pedido={pedido}
                                    statusServicoCupom={statusServicoCupom}
                                    widthScreen={widthScree}
                                    onReload={() => {
                                        if (onReload) {
                                            onReload(pedido.codigo_venda);
                                        }
                                    }} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </div>
    </>
}

export { PagamentoListagem }